import { action as apiAction } from 'api/Api'

type Payload = {
  name: string
  identifier: any
  args: any
}

const requestAddDocumentTemplateSource = (payload: Payload) => async () => {
  const { name, identifier, args } = payload

  await apiAction('AddDocumentTemplateSource', {
    name,
    identifier,
    args
  })
}

export default requestAddDocumentTemplateSource